import axios from 'axios';
import CommonUtil from '../common/CommonUtil';
import { EVENT } from '../events/listEvents';
import {GA4Common, GA_EVENT} from "./GA4Common";
import { getLangBaseOnURLPath } from './i18nConfiguration';

let defautRequestConfig = {
  baseURL: '/'
}

const defaultRestApi = axios.create(defautRequestConfig);
defaultRestApi.interceptors.request.use(function (config) {
    config.params = {
      locale: CommonUtil.toLocaleCode(getLangBaseOnURLPath()),
      '_': new Date().getTime(),
      withCredentials: true
    };
    return config;
  }, function (error) {
    // Do something with request error
    return Promise.reject(error);
  });

const sportService = '/sports-service/sv/compact/sports-markets'

defaultRestApi.interceptors.response.use(response => {    
    const status = response ? response.status : null; 
    const responseURL = response.request.responseURL;
    
    if(responseURL
          && (responseURL.includes(sportService) || responseURL.includes('casino/getCasinoSideBars'))
          && status == 200){
      window.fireEvent(EVENT.DisableMaintenancePage);
    }
    return response;
  }, error => {
  
  const status = error.response ? error.response.status : null;  
  const responseURL = error.request.responseURL;
  GA4Common.sendEventGA(GA_EVENT.PAGE_VIEW, {errorMessage: `${status}:${responseURL}`})

  if(responseURL 
        && (responseURL.includes(sportService) || responseURL.includes('casino/getCasinoSideBars'))
        && status > 200){
    window.fireEvent(EVENT.EnableMaintenancePage);    
  } 
  
  return Promise.reject(error);
})

export default defaultRestApi;




// WEBPACK FOOTER //
// ./src/app/common/RestApiInstance.js